import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";
import { SiteCreateForm } from "../components/forms/SiteCreateForm";

export const SiteCreateFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.sitesCreateFormPage" />
                <ActionBar>
                    <OkButton isDisabled={false} onClick={triggerOk} />
                    <SubmitButton isDisabled={false} onClick={triggerSubmit} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.SITES}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <SiteCreateForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
